import * as React from 'react';
import Box from '@mui/material/Box';
import InputBase from '@mui/material/InputBase';
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import SearchIcon from '@mui/icons-material/Search';
import CancelIcon from '@mui/icons-material/Cancel';
import { useNavigate, useSearchParams } from 'react-router';

export default function SearchBox(props) {
  const { onSearch } = props;
  const [searchText, setSearchText] = React.useState('');
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const q = searchParams.get('q') || '';

  React.useEffect(() => {
    updateSearchText(q);
  }, [q]);

  const handleSearch = (e) => {
    e.preventDefault();
    if (!searchText.trim()) return;
    navigate(`/search?q=${encodeURIComponent(searchText.trim())}`);
  };

  const updateSearchText = (text) => {
    setSearchText(text);
    onSearch && onSearch(text);
  };

  return (
    <Box
      component='form'
      sx={{
        p: '6px 8px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: 'calc(100% - 24px)',
        maxWidth: 560,
        height: 64,
        backgroundColor: 'transparent',
        mx: 'auto',
        borderRadius: '20px',
        marginTop: '-70px',
        position: 'relative',
        zIndex: 5,
        gap: 1,
      }}
    >
      <Box
        sx={{
          flex: 1,
          display: 'flex',
          alignItems: 'center',
          height: '100%',
          backgroundColor: '#fff',
          borderRadius: '18px',
          boxShadow: '0 14px 28px rgba(22, 22, 22, 0.08)',
          px: 1.15,
        }}
      >
        <SearchIcon sx={{ color: '#ff6767', mr: 1 }} />
        <InputBase
          sx={{ flex: 1, fontWeight: '600' }}
          placeholder='Search'
          inputProps={{ 'aria-label': 'search store' }}
          value={searchText}
          onChange={(e) => {
            updateSearchText(e.target.value);
          }}
          endAdornment={
            <InputAdornment position='end'>
              <IconButton
                aria-label='clear search text'
                onClick={() => {
                  updateSearchText('');
                }}
              >
                {searchText?.length > 0 ? (
                  <CancelIcon sx={{ color: '#b6b6b6' }} />
                ) : (
                  <></>
                )}
              </IconButton>
            </InputAdornment>
          }
        />
      </Box>
      <IconButton
        sx={{ p: '10px' }}
        aria-label='menu'
        className='search-icon-button'
        onClick={handleSearch}
      >
        <SearchIcon sx={{ color: '#ff5c67' }} />
      </IconButton>
    </Box>
  );
}
